module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_5_m_en.5451aab73da3897479db27c99578ec4d.png";